const flagModules = import.meta.glob('./*.svg', {
    eager: true,
    import: 'default',
    query: '?url'
});

const flags = Object.fromEntries(
    Object.entries(flagModules).map(([path, url]) => {
        const alpha2Code = path.replace(/^\.\//, '').replace(/\.svg$/, '');

        return [alpha2Code, url];
    })
);

export default flags;
